import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DataPoints } from "../api";

interface FeedBackPageReducerState {
    currentSessionId: string | null;
    overAllCurrentSessionDataPoints: { FAQ: Array<DataPoints>; Manuals: Array<DataPoints>; ALL: Array<DataPoints> };
}

const feedBackPageReducerInitialState: FeedBackPageReducerState = {
    currentSessionId: null,
    overAllCurrentSessionDataPoints: { FAQ: [], Manuals: [], ALL: [] }
};

const FeedBackPageComponentReducer = createSlice({
    name: "feedBackPage",
    initialState: feedBackPageReducerInitialState,
    reducers: {
        updateCurrentSessionId: (state, action: PayloadAction<string | null>) => {
            state.currentSessionId = action.payload;
        },
        updateOverAllCurrentSessionDataPoints: (
            state,
            action: PayloadAction<{ FAQ: Array<DataPoints>; Manuals: Array<DataPoints>; ALL: Array<DataPoints> }>
        ) => {
            state.overAllCurrentSessionDataPoints = action.payload;
        },
        resetOverAllCurrentSessionDataPoints: state => {
            state.overAllCurrentSessionDataPoints = { FAQ: [], Manuals: [], ALL: [] };
        }
    }
});

export const FeedBackPageComponentReducerAction = FeedBackPageComponentReducer.actions;

export default FeedBackPageComponentReducer.reducer;
